import React, { useState } from 'react';

const SearchInputComponent = ({ traits }) => {
    const { showButton, placeholder } = traits ;
    const [keyword, setKeyword] = useState('');
    return (
        <div className="relative w-full">
            <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                placeholder={placeholder}
                className="w-full bg-gray-100 rounded-full py-3 px-6 pr-10 text-gray-500 focus:outline-none"
            />
            {showButton && (
                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                    <svg
                        className="w-6 h-6 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        ></path>
                    </svg>
                </div>
            )}
        </div>
    );
};

export default SearchInputComponent;
